import { Component, Input } from '@angular/core';

@Component({
  selector: 'un-usp-link',
  templateUrl: 'usp-link.component.html',
  styleUrls: ['usp-link.component.scss'],
  standalone: false,
})
export class UspLinkComponent {
  @Input() public url?: string;
  @Input() public icon?: string;
}
